import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class fulfillmentItemsListItemCtrl implements IController {

  item: any;
  stepNumber: any;

  private weightUnit: any;
  private volumeUnit: any;
  private siteLabels: any;
  private labelsMap: any;

  /* @ngInject */
  constructor(private splitService) {}

  $onInit() {
    this.siteLabels = this.splitService.getSiteLabels();
    this.labelsMap = {};
    _.forEach(this.siteLabels, (l) => {
      this.labelsMap[l.name] = l;
    })
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
  }

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentItemsListItem', {
    bindings: {
      item: '<',
      stepNumber: '<'
    },
    template: require('./fulfillment-items-list-item.html').default,
    controller: fulfillmentItemsListItemCtrl
  });
